module.exports = __webpack_public_path__ + "media/PAG81-06.6161e97e.mp3";